<template>
   <img v-if="this.$store.state.user_auth != null && this.$store.state.user_auth.avatarUser != null && this.$store.state.user_auth.avatarUser.trim() != ''"  :src="this.$store.state.user_auth.avatarUser" alt="">
</template>
<script>
export default {
  name: 'AvatarUser',
}
</script>
